<template>
  <div>
    <div class="item" v-if="item && item.id">
      <div class="novel-container" v-if="item.type===2 || item.type === 8" @click="showItem(item)">
        <div class="novel-cover">
          <img v-lazy="item.cover_url"/>
        </div>
        <div class="novel-info">
          <div class="novel-title-box">
            <div class="novel-title">{{item.title}}</div>
            <div class="rate-container">
              <div class="rate-main">
                <div class="rate-value" v-if="item.rate_value">{{item.rate_value.toFixed(1)}}</div>
                <Rate readonly size="14" color="#ffd21e" v-model="item.rate_value"></Rate>
              </div>
              <div class="rate-desc">
                {{item.rate_desc}}
              </div>
            </div>
          </div>
          <div class="novel-description">{{item.description}}</div>
          <div class="action-box">
            <Button :type="bookshelfBtnType" plain round size="small" @click.stop="onAddToShelf(item)">{{inShelfDesc}}</Button>
            <Button type="warning" plain round size="small" @click.stop="showItem(item)">开始阅读</Button>
          </div>

          <NovelBookShelf ref="bookShelf" v-model="isInShelf" :item="item"></NovelBookShelf>
        </div>
      </div>
      <div class="item-rate-box" v-if="showItemRate">
        <div class="rate-title" v-if="!item.user_rate_value">轻点评分</div>
        <div class="rate-title" v-else>我的评分</div>
        <Rate v-model="item.user_rate_value" :readonly="Boolean(item.user_rate_value)" color="#ffd21e"
              @change="onChangeRateValue"></Rate>
      </div>
    </div>
    <div class="loading-info" v-if="showLoading">
      <Loading type="spinner"></Loading>
    </div>
  </div>
</template>
<script>
  import {Toast, Rate, Loading, Button} from "vant"
  import LoadingComponent from "../common/LoadingComponent";
  import NovelBookShelf from "../common/NovelBookShelf";

  export default {
    components: {NovelBookShelf, LoadingComponent, Toast, Loading, Rate, Button},
    name: "ItemBox",
    props: {
      itemId: {},
      showItemRate: {}
    },
    data() {
      return {
        item: {},
        isInShelf: false,
        showLoading: true,
      }
    },
    mounted() {
      if (this.itemId) {
        this.getItem()
      }
    },
    methods: {
      async getItem() {
        this.showLoading = true
        let params = {
          id: this.itemId
        }
        await this.$store.dispatch("GetUgcItem", params).then((data) => {
              if (data.code !== 0) {
              } else {
                this.item = data.data;
              }
            }, () => {
              Toast.fail("网络错误")
            }
        );
        this.showLoading = false
      },
      showItem(item) {
        if (item.type === 2) {
          this.$router.push('/novel/' + item.id);
        } else if (item.type === 8) {
          this.$router.push("/comic/" + item.id)
        }
      },
      onChangeRateValue(value) {
        this.$router.push(`/rate/item/${this.itemId}?rate=${value}`);
      },
      onAddToShelf(item) {
        this.$refs.bookShelf.onBookShelf()
      }
    },
    computed: {
      inShelfDesc() {
        if (this.isInShelf) {
          return "已加书架"
        } else {
          return "加入书架"
        }
      },
      bookshelfBtnType() {
        if (this.isInShelf) {
          return "warning"
        } else {
          return "primary"
        }
      }
    },
    watch: {
      itemId() {
        if (this.itemId) {
          this.getItem()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .item {
    width: 100%;

    .novel-container {
      display: flex;
      background: white;
      padding: 12px 4px;
      overflow: hidden;
      border-bottom: 1px solid #fafafa;
    }

    .action-box {
      margin-top: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .novel-cover {
    position: relative;
    width: 120px;
    height: 180px;
    margin-left: 4px;
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    img {
      height: 180px;
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      -moz-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      -o-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
    }
  }

  .novel-info {
    padding: 5px 28px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: grey;

    .novel-title-box {

      .rate-container {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-top: 8px;
        line-height: 1.5;
        padding: 3px 0;

        .rate-main {
          display: flex;
          align-items: center;
          margin-right: 12px;

          .rate-value {
            font-size: 20px;
            font-weight: bold;
            margin-right: 8px;
          }
        }

        .rate-desc {
          font-size: 12px;
        }
      }
    }

    .novel-title {
      font-size: 14px;
      font-weight: bold;
      line-height: 1.5;
    }

    .novel-description {
      margin-top: 12px;
      color: rgba(0, 0, 0, 0.75);
      font-size: 12px;
      line-height: 1.5;
      max-height: 150px;
      display: -webkit-box;
      -webkit-line-clamp: 5; /*显示3行，超出的用省略号代替*/
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .novel-options {
      display: flex;
      align-items: center;

      .tags {
        font-size: 12px;
        flex: 1 1 auto;
        width: 70%;
      }

      .tag-item {
        margin-right: 8px;
        margin-bottom: 5px;
      }

      .option {
      }
    }
  }

  .loading-info {
    min-height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
  }


  .item-rate-box {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 12px;
    border-bottom: 1px solid #f2f2f2;
    color: grey;

    .rate-title {
      padding: 0 24px;
    }
  }
</style>

